var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "45ktjhtkka",
    d: "M0 0h34v27.52c0 1.37-1.13 2.48-2.526 2.48H2.526C1.13 30 0 28.89 0 27.52V0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-687.000000, -304.000000) translate(662.000000, 196.000000) translate(25.000000, 104.000000) translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cdia1ai98b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#45ktjhtkka"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#DDDEDF",
    xlinkHref: "#45ktjhtkka"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.762 3.243h7.286c.894 0 1.619.726 1.619 1.622 0 .895-.725 1.621-1.62 1.621h-7.285c-.894 0-1.62-.726-1.62-1.621 0-.896.726-1.622 1.62-1.622z",
    mask: "url(#cdia1ai98b)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#cdia1ai98b)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DF4D3C",
    d: "M26.515 8.616H13.762c-2.85-.003-5.162 2.309-5.165 5.163-.001.887.226 1.759.659 2.532L2.88 5.354c4.644-6.02 13.281-7.13 19.292-2.479 1.93 1.494 3.429 3.475 4.343 5.74z",
    transform: "translate(3.238095, 12.972973)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCE2F",
    d: "M27.524 13.784c-.007 7.61-6.164 13.777-13.762 13.784-.575.002-1.15-.037-1.72-.115l6.193-11.084c1.42-2.475.573-5.633-1.892-7.064-.78-.453-1.667-.69-2.57-.69h12.742c.67 1.641 1.012 3.397 1.009 5.17z",
    transform: "translate(3.238095, 12.972973)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02A15B",
    d: "M18.235 16.369l-6.193 11.084h-.011C4.495 26.499-.842 19.607.11 12.059c.308-2.443 1.264-4.758 2.77-6.705L9.256 16.31l.034.058c1.422 2.474 4.577 3.325 7.047 1.9.789-.454 1.444-1.11 1.898-1.9z",
    transform: "translate(3.238095, 12.972973)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    d: "M18.235 16.369c-1.422 2.474-4.577 3.325-7.047 1.9-.789-.454-1.444-1.11-1.898-1.9l-.034-.058c-1.394-2.49-.508-5.64 1.978-7.036.773-.433 1.643-.66 2.528-.66h.012c.902 0 1.788.237 2.569.69 2.465 1.43 3.311 4.589 1.892 7.064z",
    transform: "translate(3.238095, 12.972973)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4385F7",
    d: "M18.235 16.369c-1.422 2.474-4.577 3.325-7.047 1.9-.789-.454-1.444-1.11-1.898-1.9l-.034-.058c-1.394-2.49-.508-5.64 1.978-7.036.773-.433 1.643-.66 2.528-.66h.012c.902 0 1.788.237 2.569.69 2.465 1.43 3.311 4.589 1.892 7.064z",
    transform: "translate(3.238095, 12.972973)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M13.743 19.527c-1 0-1.982-.264-2.847-.765-.873-.505-1.598-1.232-2.103-2.106-1.583-2.747-.643-6.26 2.1-7.845.872-.505 1.862-.77 2.87-.77 3.166-.002 5.735 2.567 5.738 5.739 0 1.01-.264 2.001-.768 2.876-1.034 1.78-2.935 2.873-4.99 2.871zm.03-10.337c-1.646-.009-3.17.868-3.99 2.297-1.267 2.2-.513 5.012 1.684 6.28 2.196 1.27 5.003.514 6.27-1.685 1.267-2.198.515-5.008-1.679-6.277-.694-.401-1.482-.613-2.284-.615h-.001z",
    transform: "translate(3.238095, 12.972973)"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.81158edacac7e6a52b1dba3e715c6687.svg";
export { ForwardRef as ReactComponent };